import { BootFileParams } from '@niknevis/vue-modules/types'
import VueLoop from 'vue-loop-helper'

export default function({ Vue }: BootFileParams) {
  Vue.use(VueLoop)
}
